import React, { Component } from "react";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import indexRoutes from "routes/index.jsx";
import Login from "views/Pages/LoginPage.jsx";
import RegisterPage from "views/Pages/RegisterPage.jsx";

import LoginPage from "layouts/Pages/Pages.jsx";
import Dashboard from "layouts/Dashboard/Dashboard.jsx";
import { truncate } from "fs";
// react plugin for creating notifications over the dashboard
import NotificationAlert from "react-notification-alert";

import axios from "axios";
import ReactGA from "react-ga";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { faCheckSquare, faCoffee } from "@fortawesome/free-solid-svg-icons";
import { runInThisContext } from "vm";

ReactGA.initialize("UA-62932919-2");
library.add(fab, faCheckSquare, faCoffee, fas, far);

const API_ext = "https://mi-tienda.nadunet.es/api/rest/";
const GET_USERNAME_URL = "nadulogin_resources/get_username.json";
const DO_LOGIN_URL = "user/login";
const DO_LOGOUT_URL = "user/logout";
/* const GET_ORDERS_URL =
  "views/commerce_backoffice_user_orders?display_id=service_user_orders"; */
const GET_ORDERS_URL = "pedidos.json";
/* const GET_ORDERS_ARTICLES_URL =
  "views/commerce_backoffice_user_orders?display_id=service_user_orders_articles"; */
const GET_ORDERS_ARTICLES_URL = "articulos-pedidos.json";
const GET_INTERNET_URL = "client_internet_info.json";
/* const GET_MOBILE_URL = "mobile_cdr_resources/get_user_mobiles.json"; */
const GET_MOBILE_URL = "user_mobiles.json";
//const GET_SERVICES_URL = "mobile_cdr_resources/get_user_services.json";
const GET_SERVICES_URL = "user_services.json";
const GET_MOBILE_CDR_URL = "cdr-mobile.json?args[0]=";
const GET_MOBILE_SERVICES = "mobile-services?timestamp=";
const CREATE_NODE = "node.json";
const FLAG_NODE = "flag/flag.json";
const GET_SIM_DELIVERIES = "sim-deliveries-minadunet";
const GET_TODAY_DATA_USAGE = "mobile_cdr_resources/get_current_day_data_cdr";
const GET_MOBILE_SERVICES_API_URL = "mobile_cdr_resources/get_mobile_info";
const GET_TV_SUBSCRIPTIONS_API_URL = "mobile_cdr_resources/get_customer_tv";
const START_PAYMENT = "nadunet_tpv_resources/start_payment";
const WAIT_PAYMENT = "nadunet_tpv_resources/wait_payment";

const SAVE_CONTRACT = "nadunet_contracts_resources/save_contract.json";

const DEBUG_MODE =
  window.location.host.includes("localhost") ||
  window.location.host.includes("192.168.");
const API = DEBUG_MODE
  ? "https://mi.nadunet.es/api/rest/"
  : "https://" + window.location.host + "/api/rest/";

//function to group array by param. Usage:
//        const groupByParamA = groupBy('paramA');
//        const groupedElements = groupByParamA(elements);
const groupBy = (key) => (array) =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key];
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
    return objectsByKeyValue;
  }, {});

const hist = createBrowserHistory();
const smallDeviceThreshold = 765;

class App extends Component {
  constructor(props) {
    super(props);

    console.log("firmas.nadunet v1.0.0");
    let isContractOpened = false;
    if (window.location.pathname.includes("/ver")) {
      isContractOpened = true;
    }
    this.state = {
      auxArrayCDR: [],
      debug: DEBUG_MODE,
      isLoggedIn: false,
      hasMobile: false,
      hasInternet: false,
      internet_plan: null,
      internetLoaded: false,
      mobiles: [],
      mobilesLoaded: false,
      mobilesCDR: [],
      mobilesCDRLoaded: false,
      mobilesLoadedCount: 0,
      ordersLoaded: false,
      ordersArticlesLoaded: false,
      retriesCDR: 0,
      width: 0,
      height: 0,
      smallDevice: false,
      resetPass: this.checkReset(),
      mobileServices: [],
      SIMDeliveries: [],
      isConfirmingSIMDelivery: [],
      todayDataUsage: [],
      isTvActive: false,
      activeTvSubscriptions: [],
      paymentStatuses: [],

      // nuevo state
      isContractOpened: isContractOpened,
      isSavingContract: false,
      isSigningContract: false,
    };

    let retrievedState = null;
    // try {
    //   retrievedState = JSON.parse(localStorage.getItem("minadunet") || "{}");
    //   // console.log("OK");
    //   if (Object.keys(retrievedState).length > 0) {
    //     this.state = retrievedState;
    //     this.godMode(null, true);
    //   }
    // } catch (e) {
    //   // console.log("ERROR");
    //   retrievedState = {};
    //   localStorage.removeItem("minadunet");
    // }

    axios.interceptors.request.use((request) => {
      //console.log("Starting Request...", request);
      return request;
    });

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.clearCookies = this.clearCookies.bind(this);
    this.showNotification = this.showNotification.bind(this);
    this.getOrders = this.getOrders.bind(this);
    this.getOrdersArticles = this.getOrdersArticles.bind(this);
    this.getServices = this.getServices.bind(this);
    this.getInternet = this.getInternet.bind(this);
    this.getMobile = this.getMobile.bind(this);
    this.signOut = this.signOut.bind(this);
    this.getMobileCDR = this.getMobileCDR.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
    this.disableRestart = this.disableRestart.bind(this);
    this.loadMobileServices = this.loadMobileServices.bind(this);
    this.getMobileServices = this.getMobileServices.bind(this);
    this.createMobileServicesWrapper = this.createMobileServicesWrapper.bind(
      this
    );
    this.modifyMobileServicesWrapper = this.modifyMobileServicesWrapper.bind(
      this
    );
    this.getSIMDeliveries = this.getSIMDeliveries.bind(this);
    this.confirmSIMDelivery = this.confirmSIMDelivery.bind(this);
    this.getMobileServicesAPI = this.getMobileServicesAPI.bind(this);
    this.getTvSubscriptions = this.getTvSubscriptions.bind(this);
    this.startPayment = this.startPayment.bind(this);
    this.waitPayment = this.waitPayment.bind(this);
    this.cleanPaymentStatuses = this.cleanPaymentStatuses.bind(this);
    this.closeContract = this.closeContract.bind(this);
    this.saveContract = this.saveContract.bind(this);
  }
  checkReset() {
    if (window.location.pathname.includes("/api/user/reset/")) {
      let resetPath = window.location.pathname;
      let splitPath = resetPath.split("/");
      let resetPassUid = splitPath[4];
      let resetPassToken = splitPath[6];
      let timestamp = splitPath[5];

      return {
        isResetPass: true,
        token: resetPassToken,
        uid: resetPassUid,
        path: splitPath,
        timestamp: timestamp,
      };
    } else {
      return {
        isResetPass: false,
        token: null,
        uid: null,
        path: null,
      };
    }
  }

  goToLogin() {
    hist.push("/entrar");
    this.disableRestart();
  }
  disableRestart() {
    this.setState({
      resetPass: {
        isResetPass: false,
      },
    });
  }

  componentDidMount() {
    try {
      window.addEventListener("beforeunload", (ev) => {
        ev.preventDefault();
        this.clearCookies();
      });
      this.updateWindowDimensions();
      window.addEventListener("resize", this.updateWindowDimensions);
      hist.listen((location) => ReactGA.pageview(location.pathname));
    } catch (error) {
      // console.log();
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      this.clearCookies();
    });
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    try {
      this.setState({
        width: window.innerWidth,
        height: window.innerHeight,
        smallDevice: window.innerWidth < smallDeviceThreshold,
      });
    } catch (error) {
      // console.log();
    }
  }

  signOut() {
    hist.push("/entrar");
    this.clearCookies();
    this.setState({
      isLoggedIn: false,
      hasMobile: false,
      hasInternet: false,
      internet_plan: null,
      internetLoaded: false,
      mobiles: [],
      mobilesLoaded: false,
      orders: null,
      ordersLoaded: false,
      ordersArticles: null,
      ordersArticlesLoaded: false,
      session: null,
      user: null,
    });
  }

  clearCookies() {
    if (this.state.session) {
      let queryHeaders = {
        "X-CSRF-Token": this.state.session.token,
      };
      axios
        .post(API + DO_LOGOUT_URL, {}, { headers: queryHeaders })
        .then((result) => {
          /* ////console.log("################## RESPUESTA LOGOUT ################");
          ////console.log(result); */
        })
        .catch((error) => {
          // Error 😨
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            /* ////console.log(error.response.data);
                ////console.log(error.response.status);
                ////console.log(error.response.headers); */
            this.setState({
              error,
              loginError: true,
            });
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            /* ////console.log(error.request); */
            this.setState({
              error,
              loginError: true,
            });
          } else {
            // Something happened in setting up the request and triggered an Error
            /* ////console.log('Error', error.message); */
            this.setState({
              error,
              loginError: true,
            });
          }
          /* ////console.log(error.config); */
        });
    }
    if (this.state.debug) {
      let cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let eqPos = cookie.indexOf("=");
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    }
  }

  checkPayment() {
    if (this.state.session) {
      let queryHeaders = {
        "X-CSRF-Token": this.state.session.token,
      };
      axios
        .post(API + DO_LOGOUT_URL, {}, { headers: queryHeaders })
        .then((result) => {
          /* ////console.log("################## RESPUESTA LOGOUT ################");
          ////console.log(result); */
        })
        .catch((error) => {
          // Error 😨
          if (error.response) {
            /*
             * The request was made and the server responded with a
             * status code that falls out of the range of 2xx
             */
            /* ////console.log(error.response.data);
                ////console.log(error.response.status);
                ////console.log(error.response.headers); */
            this.setState({
              error,
              loginError: true,
            });
          } else if (error.request) {
            /*
             * The request was made but no response was received, `error.request`
             * is an instance of XMLHttpRequest in the browser and an instance
             * of http.ClientRequest in Node.js
             */
            /* ////console.log(error.request); */
            this.setState({
              error,
              loginError: true,
            });
          } else {
            // Something happened in setting up the request and triggered an Error
            /* ////console.log('Error', error.message); */
            this.setState({
              error,
              loginError: true,
            });
          }
          /* ////console.log(error.config); */
        });
    }
    if (this.state.debug) {
      let cookies = document.cookie.split(";");

      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let eqPos = cookie.indexOf("=");
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    }
  }

  startPayment(order_id) {
    if (!order_id) {
      var options = {
        place: "tr",
        message:
          "Ya hay un pago en proceso. Finalízalo y luego podrás seguir con el siguiente.",
        type: "warning",
        icon: "now-ui-icons shopping_credit-card",
        autoDismiss: 5,
      };
      this.showNotification(options);
      return;
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      bill_id: order_id,
    };
    // console.log("################## REQUEST START PAYMENT ################");
    // console.log(request);

    axios
      .post(API + START_PAYMENT, request, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        // console.log("################## RESPUESTA START PAYMENT ################");
        // console.log(result);

        let auxPaymentStatuses = this.state.paymentStatuses;
        auxPaymentStatuses[order_id] = result.data;
        this.setState({
          paymentStatuses: auxPaymentStatuses,
        });

        this.waitPayment(order_id); //After 5 second, start checking the payment
      })
      .catch((error) => {
        var options = {
          place: "tr",
          message: "No se pudo iniciar el proceso de pago",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 5,
        };
        this.showNotification(options);
        /* ////console.log(error.config); */
      });
  }

  waitPayment(order_id) {
    let payment_id = 0;
    // console.log("################## ENTRANDO EN WAIT PAYMENT (order_id) ################");
    // console.log(order_id);
    if (order_id in this.state.paymentStatuses) {
      // console.log("################## ESTADO ENCONTRADO EN WAIT PAYMENT (paymentStatus) ################");
      // console.log(this.state.paymentStatuses[order_id].payment_id);
      payment_id = this.state.paymentStatuses[order_id].payment_id;
    } else {
      // console.log("################## ESTADO [NO] ENCONTRADO EN WAIT PAYMENT ################");
      return;
    }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      payment_id: payment_id,
    };
    // console.log("################## REQUEST WAIT_PAYMENT PAYMENT ################");
    // console.log(request);

    axios
      .post(API + WAIT_PAYMENT, request, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        // console.log("################## RESPUESTA WAIT PAYMENT ################");
        // console.log(result);

        if (parseInt(result.data.payment_status) != 222) {
          let auxPaymentStatuses = this.state.paymentStatuses;
          let currentPaymentStatus = null;
          if (order_id in auxPaymentStatuses) {
            currentPaymentStatus = auxPaymentStatuses[order_id];
          } else {
            return;
          }
          currentPaymentStatus.payment_status = parseInt(
            result.data.payment_status
          );
          currentPaymentStatus.payment_result = parseInt(
            result.data.payment_result
          );
          auxPaymentStatuses[order_id] = currentPaymentStatus;
          this.setState({
            paymentStatuses: auxPaymentStatuses,
          });
          this.getOrders();
          return;
        } else {
          setTimeout(
            function() {
              //Start the timer
              this.waitPayment(order_id); //After 2 second, re-check the payment
            }.bind(this),
            2000
          );
          return;
        }
      })
      .catch((error) => {
        // var options = {
        //   place: "tr",
        //   message: "No se pudo iniciar el proceso de pago",
        //   type: "danger",
        //   icon: "now-ui-icons ui-1_check",
        //   autoDismiss: 5
        // };
        // this.showNotification(options);
        /* ////console.log(error.config); */
      });
  }

  cleanPaymentStatuses() {
    this.setState({ paymentStatuses: [] });
  }

  getOrders() {
    /* ////console.log("################## GET ORDERS ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    axios
      .get(API + GET_ORDERS_URL, queryHeaders, { withCredentials: true })
      .then((result) => {
        //console.log("################## RESPUESTA GET ORDERS ################");
        //console.log(result);

        this.setState({
          ordersLoaded: true,
          orders: result.data,
        });
        var options = {
          place: "tr",
          message: "Facturas cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        /* ////console.log("################## ERROR ################"); */
      });
  }

  getOrdersArticles() {
    /* ////console.log("################## GET ORDERS ARTICLES ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    axios
      .get(API + GET_ORDERS_ARTICLES_URL, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        /* console.log("################## RESPUESTA GET_ORDERS_ARTICLES_URL ################");
        console.log(result); */

        /* numero_pedido: "4120174190"
        tipo: "Producto"
        total: "29,95 €"
        título: "∞ min + 10GB (Móvil)" */

        const groupedArticles = result.data.reduce(
          (currentOrder, { numero_pedido, total, titulo }) => {
            (currentOrder[numero_pedido] =
              currentOrder[numero_pedido] || []).push({ total, titulo });
            return currentOrder;
          },
          {}
        );

        this.setState({
          ordersArticlesLoaded: true,
          ordersArticles: groupedArticles,
        });
        var options = {
          place: "tr",
          message: "Artículos de facturas cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        /* ////console.log("################## ERROR ################"); */
      });
  }

  getServices() {
    /* ////console.log("################## GET SERVICES ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    axios
      .get(API + GET_SERVICES_URL, { headers: queryHeaders.headers })
      .then((result) => {
        //console.log("################## RESPUESTA GET SERVICES ################");

        let jsonResult = result.data[0];
        //console.log(jsonResult);

        if (jsonResult.internet === "1") {
          this.getInternet();
        }
        if (jsonResult.mobile === "1") {
          this.getMobile();
        }

        this.setState({
          hasMobile: jsonResult.mobile === "1",
          hasInternet: jsonResult.internet === "1",
          mobilesLoaded: jsonResult.mobile === "0",
          internetLoaded: jsonResult.internet === "0",
          mobilesCDRLoaded: jsonResult.mobile === "0",
        });
        var options = {
          place: "tr",
          message: "Servicios obtenidos",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        /* ////console.log("################## ERROR ################"); */
      });
  }

  getInternet() {
    /* ////console.log("################## GET INTERNET ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    axios
      .get(API + GET_INTERNET_URL, queryHeaders, { withCredentials: true })
      .then((result) => {
        /* ////console.log("################## RESPUESTA GET INTERNET ################");
        ////console.log(result); */

        if (result && result.data && result.data[0]) {
          this.setState({
            internet_plan: {
              name: result.data[0].internet_plan.replace(" (Internet)", ""),
              price: result.data[0].precio,
            },
            internetLoaded: true,
          });
        }
        var options = {
          place: "tr",
          message: "Internet cargado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch((error) => {
        /* ////console.log("################## ERROR ################"); */
      });
  }

  getSIMDeliveries() {
    /* ////console.log("################## GET INTERNET ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    axios
      .get(API + GET_SIM_DELIVERIES, queryHeaders, { withCredentials: true })
      .then((result) => {
        /* ////console.log("################## RESPUESTA GET INTERNET ################");
        ////console.log(result); */

        if (result && result.data && result.data[0]) {
          this.setState({
            SIMDeliveries: result.data,
          });
        }
        var options = {
          place: "tr",
          message: "Envíos de SIMs cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
      })
      .catch((error) => {
        /* ////console.log("################## ERROR ################"); */
      });
  }

  getMobile() {
    /* ////console.log("################## GET MOBILE ################"); */
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    axios
      .get(API + GET_MOBILE_URL, { headers: queryHeaders.headers })
      .then((result) => {
        //console.log("################## RESPUESTA GET MOBILE ################");

        let jsonResult = result.data;
        // console.log("###### get mobile ######");
        // console.log(jsonResult);
        //console.log(jsonResult);
        /* let mobiles = [];
        jsonResult.resultado.map((currentMobile, key) =>{
          mobiles[currentMobile.mobile] = currentMobile.plan;
        }); 
        ////console.log("Mobiles array");
        ////console.log(mobiles); */

        const groupByNumber = groupBy("numero");
        const groupedResult = groupByNumber(jsonResult);

        this.setState({
          mobiles: jsonResult,
          mobilesLoaded: true,
          mobilesGrouped: groupedResult,
        });

        //Obtain mobile CDR if there is any mobile
        jsonResult.map((mobile) => {
          this.getTodayDataUsage(mobile.mobile);
          this.getMobileCDR(mobile.mobile);
        });
        //this.getMobileCDR();

        var options = {
          place: "tr",
          message: "Móviles cargados",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        /* ////console.log("################## ERROR ################"); */
      });
  }

  getMobileCDR(number) {
    ////console.log("################## GET MOBILE CDR ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    /* this.state.mobiles.forEach(function iterator(currentMobileObject) { */
    let currentMobile = number;
    axios
      .get(API + GET_MOBILE_CDR_URL + currentMobile, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        // console.log(
        //   "################## RESPUESTA GET CDR " +
        //     currentMobile +
        //     " ################"
        // );
        // console.log(result);

        if (result && result.data) {
          /* let auxCDR = { [currentMobile]: result.data }; */

          const groupByRegistryType = groupBy("tipo_consumo");
          const groupedResult = groupByRegistryType(result.data);

          const groupedCDR = {
            origen: currentMobile,
            cdr: groupedResult,
          };

          let newMobilesCDR = this.state.auxArrayCDR.concat(groupedCDR);
          /* //console.log("############### newMobilesCDR #############");
          //newMobilesCDR.push.apply(newMobilesCDR, groupedRegistries);
          //console.log(newMobilesCDR); */

          let mobilesLoadedCount = this.state.mobilesLoadedCount + 1;
          let mobilesCDRLoaded =
            this.state.mobiles.length == mobilesLoadedCount;

          if (mobilesCDRLoaded) {
            const groupByNumber = groupBy("origen");
            const groupedRegistries = groupByNumber(newMobilesCDR);
            /* this.state.auxArrayCDR.reduce((current_registry, { origen, destino, tipo_consumo, consumo, importe, fecha, descripción }) => {
              (current_registry[origen] = current_registry[origen] || []).push({ destino, tipo_consumo, consumo, importe, fecha, descripción });
              return current_registry;
            }, {}); */
            /* //console.log("############### groupedRegistries #############");
            //newMobilesCDR.push.apply(newMobilesCDR, groupedRegistries);
            //console.log(groupedRegistries); */

            this.setState({
              mobilesCDR: groupedRegistries,
              auxArrayCDR: newMobilesCDR,
              mobilesCDRLoaded: mobilesCDRLoaded,
              mobilesLoadedCount: mobilesLoadedCount,
            });
          } else {
            this.setState({
              auxArrayCDR: newMobilesCDR,
              mobilesCDRLoaded: mobilesCDRLoaded,
              mobilesLoadedCount: mobilesLoadedCount,
            });
          }

          /* let auxCDR = this.state.mobilesCDR.slice().push(result.data);

          let mobilesAlreadyLoaded = ((this.state.mobilesLoadedCount + 1) == this.state.mobiles.length);

          this.setState({
            mobilesCDR: auxCDR,
            mobilesCDRLoaded: mobilesAlreadyLoaded,
            mobilesLoadedCount: this.state.mobilesLoadedCount + 1
          }); */
          var options = {
            place: "tr",
            message: "CDR del móvil " + currentMobile + " cargado",
            type: "primary",
            icon: "now-ui-icons ui-1_check",
            autoDismiss: 3,
          };
          if (this.state.debug) this.showNotification(options);
        } else if (this.state.retriesCDR < 5) {
          const retries = this.state.retriesCDR + 1;
          this.setState({
            retriesCDR: retries,
          });
          this.getMobileCDR(currentMobile);
        } else {
          this.setState({
            mobilesCDRLoaded: true,
            mobilesLoadedCount: this.state.mobilesLoadedCount + 1,
          });
        }
      })
      .catch((error) => {
        /* ////console.log("################## ERROR ################"); */
      });
    /* }, this); */
  }

  loadMobileServices(timestamp, mobile, watermark) {
    // console.log("################## OBTENIENDO SERVICIOS DEL MÓVIL (" + mobile + ") ################");
    // console.log("timestamp: " + timestamp);
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });
    // let customerID = query ? query : 0; //En caso de no introducir query, tomará el ID = 0 para saber que busca todos
    //console.log("################## customer ID en search procedure ################");
    //console.log(customerID);
    //console.log("################## isSearchingMobileProcedures en search procedure ################");
    //console.log(this.state.isSearchingMobileProcedures);
    // if (customerID in this.state.isSearchingCustomerNotes && this.state.isSearchingCustomerNotes[customerID]) {
    //   //console.log("################## YA ESTÁ EN SEARCH MOBILE PROCEDURES (" + query + ") ################");
    //   return;
    // } else {
    //   let searchingAux = this.state.isSearchingCustomerNotes;
    //   searchingAux[customerID] = true;
    //   this.setState({
    //     isSearchingCustomerNotes: searchingAux
    //   });
    // }
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    axios
      .get(
        API + GET_MOBILE_SERVICES + timestamp + "&mobile=" + mobile,
        queryHeaders,
        { withCredentials: true }
      )
      .then((result) => {
        // console.log("################## RESPUESTA SERVICIOS DEL MÓVIL (" + mobile + ") ################");
        // console.log(result);
        // const groupByID = groupBy('usuario_relacionado_id');
        // const groupedByID = groupByID(result.data);
        // // let customersToSearch = Object.keys(groupedByID);
        // //console.log(groupedByID);
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        // let searchingAux = this.state.isSearchingCustomerNotes;
        // searchingAux[customerID] = false;

        if (result.data.length == 0) {
          setTimeout(
            function() {
              // console.log("################## INTENTANDO OBTENER DE NUEVO LOS SERVICIOS DEL MÓVIL (" + mobile + ") ################");
              this.loadMobileServices(timestamp, mobile);
            }.bind(this),
            2000
          );
          return;
        }

        let mobileServicesAux = this.state.mobileServices;
        let resultAux = result.data[0].respuesta_api.replace(/&quot;/g, '"');
        try {
          // console.log("################## resultAux ################");
          // console.log(resultAux);
          resultAux = JSON.parse(resultAux);
          // console.log("################## resultAux PARSED ################");
          // console.log(resultAux);
        } catch (error) {
          // console.log("################## ERROR parsing JSON ################");
          // console.log(error);
        }
        result.data[0].respuesta_api = resultAux;
        result.data[0].watermark = watermark;
        mobileServicesAux[mobile] = result.data[0];

        this.setState({
          // isSearchingCustomerNotes: searchingAux,
          mobileServices: mobileServicesAux,
        });
        var options = {
          place: "tr",
          message: "Servicios del móvil " + mobile + " obtenidos.",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }
  getTvSubscriptions() {
    // console.log("################## OBTENIENDO SERVICIOS DEL MÓVIL (" + mobile + ") ################");
    // console.log("timestamp: " + timestamp);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      id: [],
    };
    axios
      .post(API + GET_TV_SUBSCRIPTIONS_API_URL, request, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        // console.log("################## RESPUESTA SERVICIOS DEL MÓVIL (" + mobile + ") ################");
        // console.log(result);
        // const groupByID = groupBy('usuario_relacionado_id');
        // const groupedByID = groupByID(result.data);
        // // let customersToSearch = Object.keys(groupedByID);
        // //console.log(groupedByID);
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        // let searchingAux = this.state.isSearchingCustomerNotes;
        // searchingAux[customerID] = false;

        this.setState({
          // isSearchingCustomerNotes: searchingAux,
          isTvActive: result.data.isActive,
          activeTvSubscriptions: result.data.subscriptions,
        });
        var options = {
          place: "tr",
          message: "Subscripciones de TV cargadas",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }
  getMobileServicesAPI(mobile) {
    // console.log("################## OBTENIENDO SERVICIOS DEL MÓVIL (" + mobile + ") ################");
    // console.log("timestamp: " + timestamp);
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      mobile: parseInt(mobile),
    };
    axios
      .post(API + GET_MOBILE_SERVICES_API_URL, request, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        // console.log("################## RESPUESTA SERVICIOS DEL MÓVIL (" + mobile + ") ################");
        // console.log(result);
        // const groupByID = groupBy('usuario_relacionado_id');
        // const groupedByID = groupByID(result.data);
        // // let customersToSearch = Object.keys(groupedByID);
        // //console.log(groupedByID);
        //console.log("################## customer ID en respuesta search procedure ################");
        //console.log(customerID);

        // let searchingAux = this.state.isSearchingCustomerNotes;
        // searchingAux[customerID] = false;

        let mobileServicesAux = this.state.mobileServices;
        mobileServicesAux[mobile] = result.data;

        this.setState({
          // isSearchingCustomerNotes: searchingAux,
          mobileServices: mobileServicesAux,
        });
        var options = {
          place: "tr",
          message: "Servicios del móvil " + mobile + " obtenidos.",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        //console.log("################## CUSTOMERS MOBILES KEYS ################");
        //console.log(customersToSearch);
        // this.searchCustomer(customersToSearch, true);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        //console.log("################## ERROR GET CUSTOMERS ################");
      });
  }

  getMobileServices(mobile_id, mobile, watermark) {
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let d = new Date();
    d.setSeconds(d.getSeconds() - 10);
    let dformat =
      [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
      " " +
      [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
    let timestamp = dformat;

    this.createMobileServicesWrapper(mobile_id, mobile, timestamp, watermark);
    return;

    let request = {
      flag_name: "obtener_servicios_movil",
      entity_id: mobile_id,
      action: "flag",
    };

    //console.log("################## CANCEL PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + FLAG_NODE, request, queryHeaders, { withCredentials: true })
      .then((result) => {
        //console.log("################## RESPUESTA CANCEL MOBILE PROCEDURE ################");
        //console.log(result);

        // this.searchCustomer(customer, null, null, false, true);
        this.loadMobileServices(timestamp, mobile);

        var options = {
          place: "tr",
          message: "Obteniendo servicios del móvil",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        // this.searchMobileProcedures(customer);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        var options = {
          place: "tr",
          message: "Error al obtener los servicios del móvil",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        /*if (this.state.debug)*/ this.showNotification(options);
      });
  }

  createMobileServicesWrapper(mobile_id, mobile, timestamp, watermark) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      title_field: {
        und: [
          {
            value: "Wrapper obtención de servicios " + mobile,
          },
        ],
      },
      type: "wrapper_obtencion_servicios_movi",
      body: null,
      field_id_movil: {
        und: [
          {
            value: mobile_id,
          },
        ],
      },
      field_numero_movil: {
        und: [
          {
            value: mobile,
          },
        ],
      },
    };
    // console.log("################## CREATE NOTE QUERY ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_NODE, request, queryHeaders, { withCredentials: true })
      .then((result) => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);
        this.loadMobileServices(timestamp, mobile, watermark);

        var options = {
          place: "tr",
          message: "Obteniendo servicios del móvil",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        var options = {
          place: "tr",
          message: "Error al obtener los servicios del móvil",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        /*if (this.state.debug)*/ this.showNotification(options);
      });
  }

  modifyMobileServicesWrapper(mobile, service_json, service_name) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      title_field: {
        und: [
          {
            value: "Wrapper modificación de servicios " + mobile,
          },
        ],
      },
      type: "wrapper_modificacion_servicios",
      body: null,
      field_json_servicios: {
        und: [
          {
            value: service_json,
          },
        ],
      },
      field_numero_movil: {
        und: [
          {
            value: mobile,
          },
        ],
      },
    };
    // console.log("################## CREATE NOTE QUERY ################");
    // console.log(JSON.stringify(request));
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_NODE, request, queryHeaders, { withCredentials: true })
      .then((result) => {
        //console.log("################## RESPUESTA CREATE MOBILE PROCEDURE ################");
        //console.log(result);
        // this.loadMobileServices(timestamp, mobile);

        var options = {
          place: "tr",
          message: "Modificado el servicio " + service_name,
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        var options = {
          place: "tr",
          message: "Error al modificar el servicio " + service_name,
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        /*if (this.state.debug)*/ this.showNotification(options);
      });
  }

  showNotification(optionsInput) {
    if (optionsInput != null) {
      this.refs.notificationAlert.notificationAlert(optionsInput);
    } else {
      var message = "Notificación genérica...";
      var options = {
        place: "tr",
        message: message,
        type: "primary",
        icon: "now-ui-icons ui-1_check",
        autoDismiss: 3,
      };
      this.refs.notificationAlert.notificationAlert(options);
    }
  }

  confirmSIMDeliveryBAK(delivery) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (
      delivery in this.state.isConfirmingSIMDelivery &&
      this.state.isConfirmingSIMDelivery[delivery]
    ) {
      return;
    }

    let auxIsConfirming = this.state.isConfirmingSIMDelivery;
    if (!(delivery in auxIsConfirming)) {
      auxIsConfirming[auxIsConfirming] = true;
    }

    this.setState({
      isConfirmingSIMDelivery: auxIsConfirming,
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      flag_name: "sim_recibida",
      entity_id: delivery.toString(),
      action: "flag",
    };

    //console.log("################## CANCEL PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + FLAG_NODE, request, queryHeaders, { withCredentials: true })
      .then((result) => {
        //console.log("################## RESPUESTA CANCEL MOBILE PROCEDURE ################");
        //console.log(result);

        let auxIsConfirming = this.state.isConfirmingSIMDelivery;
        auxIsConfirming[delivery] = false;

        this.setState({
          isConfirmingSIMDelivery: auxIsConfirming,
        });
        var options = {
          place: "tr",
          message: "¡Recepción de SIM confirmada!",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 7,
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        this.getSIMDeliveries();
        //this.getOrdersArticles();
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let auxIsConfirming = this.state.isConfirmingSIMDelivery;
        auxIsConfirming[delivery] = false;

        this.setState({
          isConfirmingSIMDelivery: auxIsConfirming,
        });

        var options = {
          place: "tr",
          message:
            "Error al confirmar la recepción de la SIM. Vuelve a intentarlo.",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        /*if (this.state.debug)*/ this.showNotification(options);
      });
  }

  confirmSIMDelivery(delivery) {
    ////console.log("################## GET CUSTOMERS ################");
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    if (
      delivery in this.state.isConfirmingSIMDelivery &&
      this.state.isConfirmingSIMDelivery[delivery]
    ) {
      return;
    }

    let auxIsConfirming = this.state.isConfirmingSIMDelivery;
    if (!(delivery in auxIsConfirming)) {
      auxIsConfirming[auxIsConfirming] = true;
    }

    this.setState({
      isConfirmingSIMDelivery: auxIsConfirming,
    });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    let request = {
      title_field: {
        und: [
          {
            value: "Wrapper confirmar recepción SIM",
          },
        ],
      },
      type: "wrapper_confirmar_recepcion_sim",
      body: [],
      // field_cliente_relacionado: { und: this.checkValue(cliente) },
      field_id_envio_sim_relacionado: {
        und: [
          {
            value: delivery,
          },
        ],
      },
    };
    //console.log("################## CREATE PROCEDURE PARAMS ################");
    //console.log(tipo);
    //console.log("################## CREATE PROCEDURE REQUEST ################");
    //console.log(request);

    axios
      .post(API + CREATE_NODE, request, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        let auxIsConfirming = this.state.isConfirmingSIMDelivery;
        auxIsConfirming[delivery] = false;

        this.setState({
          isConfirmingSIMDelivery: auxIsConfirming,
        });
        var options = {
          place: "tr",
          message: "¡Recepción de SIM confirmada!",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 7,
        };
        /*if (this.state.debug)*/ this.showNotification(options);
        this.getSIMDeliveries();
      })
      .catch((error) => {
        //console.log("################## ERROR CANCEL MOBILE PROCEDURE ################");
        //console.log(error);

        let auxIsConfirming = this.state.isConfirmingSIMDelivery;
        auxIsConfirming[delivery] = false;

        this.setState({
          isConfirmingSIMDelivery: auxIsConfirming,
        });

        var options = {
          place: "tr",
          message:
            "Error al confirmar la recepción de la SIM. Vuelve a intentarlo.",
          type: "danger",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
      });
  }

  checkValue(value) {
    ////console.log("################## Checking value ################");
    ////console.log(value);
    return value
      ? value.value
        ? value.value.toString()
        : value.toString()
      : null;
  }

  getTodayDataUsage(query) {
    // console.log("################## GET TODAY USAGE (" + query + ") ################");
    query = parseInt(query);
    /* let request = {
      username: this.state.username,
      password: this.state.passField
    }; */
    //this.setState({ isLoading: true });

    let queryHeaders = {
      headers: {
        "X-CSRF-Token": this.state.session.token,
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };
    let request = {
      mobile: query,
    };
    axios
      .post(API + GET_TODAY_DATA_USAGE, request, queryHeaders, {
        withCredentials: true,
      })
      .then((result) => {
        // console.log("################## RESPUESTA GET TODAY USAGE (" + query + ") ################");
        // // // console.log("################## RESPUESTA GET ORDERS ################");
        // console.log(result);

        let auxTodayUsage = this.state.todayDataUsage;
        auxTodayUsage[query] = result.data;

        this.setState({
          todayDataUsage: auxTodayUsage,
        });
        var options = {
          place: "tr",
          message: "Uso de datos diario cargado",
          type: "primary",
          icon: "now-ui-icons ui-1_check",
          autoDismiss: 3,
        };
        if (this.state.debug) this.showNotification(options);
        /* this.props.godMode(result);
        if(result !== null && result.length > 0 && result[0] !== ""){ */
        /* this.setState({
            username: result[0],
            loginError: false
          }); */
        //doLogin();
        //}
      })
      .catch((error) => {
        /* //////console.log("################## ERROR ################"); */
      });
  }

  godMode(contract, pin) {
    console.log("##### CONTRACT #####");
    console.log(contract);
    this.setState({
      contract: contract,
      pin: pin,
      isContractOpened: true,
    });
  }

  componentDidUpdate() {
    // console.log("Saving to localStorage \"minadunet\"");
    // console.log(this.state);
    try {
      // localStorage.setItem("minadunet", JSON.stringify(this.state));
    } catch (e) {}
  }

  saveContract(contract) {
    if (this.state.isSavingContract) return;
    /* ////console.log("################## GET USERNAME ################"); */

    this.setState({
      isSavingContract: true,
      isSigningContract: contract.signature || false,
    });

    let request = {
      contract: {
        contract_id: this.state.contract.contract_id,
        pin: this.state.contract.pin,
      },
    };
    Object.keys(contract).map((current) => {
      request.contract[current] = contract[current];
    });
    /* ////console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .post(API + SAVE_CONTRACT, request, { withCredentials: false })
      .then((result) => {
        this.setState({
          isSavingContract: false,
          isSigningContract: false,
        });
        if (result.data.result === "OK") {
          console.log("respuesta save OK");
          var options = {
            place: "tr",
            message:
              "Contrato " + (contract.signature ? "firmado" : "guardado"),
            type: "primary",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3,
          };
          this.showNotification(options);
          this.setState({ isContractOpened: false });
        } else {
          var options = {
            place: "tr",
            message: "No se pudo guardar el contrato",
            type: "danger",
            icon: "now-ui-icons files_paper",
            autoDismiss: 3,
          };
          this.showNotification(options);
        }
      })
      .catch((error) => {
        this.setState({
          isLoadingContract: false,
          isSigningContract: false,
        });
        /* ////console.log(error.config); */
      });
  }

  closeContract(contractToSave) {
    if (contractToSave) {
      this.saveContract(contractToSave);
    } else {
      this.setState({ isContractOpened: false });
    }
  }

  onToggleList = () => {
    this.setState((prevState) => ({ toggle: !prevState.toggle }));
  };

  render() {
    if (this.state.isContractOpened) {
      return (
        <div>
          <NotificationAlert ref="notificationAlert" />
          <Router history={hist}>
            <Switch>
              <Route
                path="/"
                render={(props) => (
                  <Dashboard
                    {...props}
                    state={this.state}
                    closeContract={this.closeContract.bind(this)}
                    showNotification={this.showNotification.bind(this)}
                  />
                )}
              />
              {/* {indexRoutes.map((prop, key) => {
                    return <Route path={prop.path} key={key} component={prop.component} />;
                })} */}
            </Switch>
          </Router>
        </div>
      );
    } else {
      return (
        <div>
          <NotificationAlert ref="notificationAlert" />
          <Router history={hist}>
            <Switch>
              <Route
                path="/"
                render={(props) => (
                  <LoginPage
                    {...props}
                    godMode={this.godMode.bind(this)}
                    showNotification={this.showNotification.bind(this)}
                    mainState={this.state}
                  />
                )}
              />
            </Switch>
          </Router>
        </div>
      );
    }
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.jsx